<div [formGroup]='inputForm' class='container'>
  <div *ngIf='value === states.CampaignsSuspended' class='alert alert-danger' style='width: 400px'>
    <p class='m-0'>User's subscription cost will be switched to 75 USD/m. The next billing cycle will calculate the
      amount due. If you switch the user back to "Enable emails" prorated rate for the period while user was with
      suspended campaigns will be calculated with the upcoming invoice</p>
  </div>
  <div class='row'>
    <div class='col col-12'>
      <mat-radio-group class='radio-buttons' formControlName='enableEmails'>
        <mat-radio-button class='me-2' value='EmailsEnabled'
        >Enable emails
        </mat-radio-button
        >
        <mat-radio-button class='me-2' value='CampaignsSuspended'
        >Suspend campaigns
        </mat-radio-button
        >
        <mat-radio-button class='me-2' value='EmailsSuspended'
        >Suspend emails
        </mat-radio-button
        >
      </mat-radio-group>
    </div>
  </div>
</div>
